<script setup>
import { inject, ref, computed, watch } from 'vue';
import AutoComplete from 'primevue/autocomplete';

const modele = inject('modele');
const getParametre = inject('getParametre');

const { jeuDonneesCourant } = defineProps({
	jeuDonneesCourant: Object
});

const emit = defineEmits(['changementJeuDonnees']);

const nomCampagne = ref(jeuDonneesCourant?.campagne);
const valeursParametres = ref(jeuDonneesCourant.hypotheses.map(hyp => hyp.valeurFormatee));
const nomsCampagnesSuggerees = ref(null);
const valeursParamSuggerees = ref(jeuDonneesCourant.hypotheses.map(hyp => []));

const nomsCampagnes = computed(() => {
	return modele.value.donnees.valeursJeuxExistants.campagnes;
});

const valeursParametresExistantes = computed(() => {
	return modele.value.donnees.valeursJeuxExistants.parametres;
});

watch(() => jeuDonneesCourant.campagne, (campagne) => {
	nomCampagne.value = campagne;
});

watch(() => jeuDonneesCourant.hypotheses.map(hyp => hyp.valeurFormatee), (valeursParam) => {
	valeursParametres.value = valeursParam;
});

function rafraichirNomsCampagnesSuggerees(event) {
	if (nomsCampagnes.value) {
		const texteSaisi = event.query.toLowerCase();
		nomsCampagnesSuggerees.value = nomsCampagnes.value.filter(nomCtxt => nomCtxt.toLowerCase().includes(texteSaisi));
	} else {
		nomsCampagnesSuggerees.value = null;
	}
}

function rafraichirValeursParamSuggerees(event, indiceParametre) {
	const texteSaisi = event.query.toLowerCase();
	const parametre = modele.value.schema.parametres[indiceParametre];
	valeursParamSuggerees.value[indiceParametre] = valeursParametresExistantes.value.find(valParam => valParam.idParametre === parametre.id).valeurs.filter(val => val.toLowerCase().includes(texteSaisi));
}

function ouvrirJeuDonneesModifie(critereModifie, valeur, indiceParametre) {
	const jeuDonneesModifie = {};
	Object.assign(jeuDonneesModifie, jeuDonneesCourant);
	if (critereModifie === 'hypotheses') {
		jeuDonneesModifie[critereModifie][indiceParametre].valeur = valeur;
	} else {
		jeuDonneesModifie[critereModifie] = valeur;
	}
	emit('changementJeuDonnees', jeuDonneesModifie);
}

</script>

<template>
	<div class="panel-coord-jeu">
		<label class="intitule">Campagne :</label>
		<AutoComplete class="saisie"
			v-model="nomCampagne" 
			:min-length="0"
			:delay="0"
			:suggestions="nomsCampagnesSuggerees" 
			@blur="nomCampagne = jeuDonneesCourant.campagne"
			@complete="rafraichirNomsCampagnesSuggerees"
			@keydown.enter="ouvrirJeuDonneesModifie('campagne', nomCampagne)" />
		<template v-for="(hypothese, indiceParametre) in jeuDonneesCourant.hypotheses">
			<label class="intitule" v-tooltip="getParametre(hypothese.idParametre).libelle">{{ getParametre(hypothese.idParametre).libelle }} :</label>
			<AutoComplete class="saisie"
				v-model="valeursParametres[indiceParametre]" 
				:min-length="0"
				:delay="0"
				:suggestions="valeursParamSuggerees[indiceParametre]" 
				@focus="valeursParametres[indiceParametre] = hypothese.valeur"
				@blur="valeursParametres[indiceParametre] = hypothese.valeurFormatee"
				@complete="(event) => rafraichirValeursParamSuggerees(event, indiceParametre)"
				@keydown.enter="ouvrirJeuDonneesModifie('hypotheses', valeursParametres[indiceParametre], indiceParametre)" />
		</template>
	</div>
</template>

<style scoped>

.panel-coord-jeu {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	gap: 2px;
	align-items: center;
	margin-bottom: 5px;
}

.saisie {
	max-height: 2rem;
	min-width: 3px;
}

</style>

